import React from "react";
import { Link, DisabledPrompt, useParams } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function ReplaceCardConfirmView
 * @return {React.Component}
 * @exported true
 * @description The main component for ReplaceCardConfirmView
 */
export default function ReplaceCardConfirmView(props) {
  const cardID = useParams().cardID ?? "0";
  const view = `/home/recenttransactions/${ cardID }`;

  return (
      <div className="replace-card-confirm-view text-center">
        <div className="framed-icon-container">
          <SVGAsset id="SentNewCardIcon" className="sent-new-card-icon" />
          <SVGAsset id="CheckmarkCircleIcon" className="CheckmarkCircleIcon" />
        </div>
        <p><b>Your new card is on its way!</b></p>
        <p>You can continue using your current card until your new card is delivered and activated.</p>
        <span>In case of issues or concerns, <DisabledPrompt><Link>Contact Us</Link></DisabledPrompt></span>
        <Link to={ view } className="flex-container flex-horizontal align-center-container view-card-details-container">
          <div className="set-width">
            <SVGAsset id="CardOutlineIcon" className="card-outline-icon" />
          </div>
          <div className="flex-width text-left">
            <span>View Card Details</span>
          </div>
          <div className="set-width">
            <SVGAsset id="RightChevronIcon" className="right-chevron-icon chevron-icon" />
          </div>
        </Link>
      </div>
  )
}
